import React, { useCallback, useMemo } from 'react';
import { get, map, size, flow, filter, every, identity } from 'lodash/fp';
import PropTypes from 'prop-types';
import {
  FlexCol,
  InstallationOnlyModalHeader1,
  InstallationOnlyModalHeader2,
  InstallationOnlyModalTotals,
  WindowSelection,
  WindowCountRow,
  SelectedCount,
  SelectAllToggle,
  Room,
  RoomList,
  RoomHeader,
  RoomLabel,
  RoomName,
  WindowList,
  WindowListItem,
} from './styles';
import InstallationPricing from '../../InstallationPricing/InstallationPricing';
import Checkbox from '../../FormElements/Checkbox';
import Price from '../../Price';

const InstallationOptions = ({
  className,
  containers,
  selectedItems,
  toggleItem,
  toggleAll,
  pricing,
}) => {
  const checkboxItemCount = useMemo(
    () => flow(
      filter(identity),
      size,
    )(selectedItems),
    [selectedItems],
  );

  const handleOnChange = useCallback((e) => {
    const itemId = e.target.id.replace('checkbox-', '');
    toggleItem(itemId);
  }, [selectedItems]);

  const toggleAllText = useMemo(
    () => (every(identity, selectedItems)
      ? 'Clear All'
      : 'Select All'),
    [selectedItems],
  );

  return (
    <FlexCol className={className}>
      <InstallationOnlyModalHeader1>Window Selection</InstallationOnlyModalHeader1>
      <p>
        Check all windows below that you want to have installed:
      </p>
      <WindowSelection>
        <WindowCountRow>
          <SelectedCount>{checkboxItemCount} Selected</SelectedCount>
          <SelectAllToggle onClick={toggleAll}>{toggleAllText}</SelectAllToggle>
        </WindowCountRow>
        <RoomList>
          {map(({ charLabel, name, items }) => (
            <Room key={charLabel}>
              <RoomHeader>
                <RoomLabel>{charLabel}</RoomLabel>
                <RoomName>{name}</RoomName>
              </RoomHeader>
              <WindowList>
                {map(({ itemId, label }) => (
                  <WindowListItem key={itemId}>
                    <Checkbox
                      id={`checkbox-${itemId}`}
                      checked={selectedItems[itemId]}
                      label={label}
                      onChange={handleOnChange}
                    />
                  </WindowListItem>
                ))(items)}
              </WindowList>
            </Room>
          ))(containers)}
        </RoomList>
      </WindowSelection>
      <InstallationOnlyModalHeader2>Installation Cost Breakdown:</InstallationOnlyModalHeader2>
      <InstallationPricing {...pricing} />

      <InstallationOnlyModalTotals>
        <div>Total Cost</div>
        <Price>{get('totalInstallationCost', pricing)}</Price>
      </InstallationOnlyModalTotals>
    </FlexCol>);
};

InstallationOptions.propTypes = {
  className: PropTypes.string,
  selectedItems: PropTypes.shape({}).isRequired,
  toggleItem: PropTypes.func.isRequired,
  toggleAll: PropTypes.func.isRequired,
  pricing: PropTypes.shape({}).isRequired,
  containers: PropTypes.arrayOf(PropTypes.shape({})),
};
InstallationOptions.defaultProps = {
  className: '',
  containers: [],
};

export default InstallationOptions;
